import { Box } from '@amzn/meridian';
import { useCampaignConfig } from 'features/traffic/campaigns/hooks/useCampaignConfig';

export const GlobalContentEditor = () => {
  const campaignConfig = useCampaignConfig();
  const CampaignSpecificGlobalContentEditor = campaignConfig.contentSection.GlobalContentEditor;
  if (!CampaignSpecificGlobalContentEditor) return null;

  return (
    <Box spacingInset="300 400 400">
      <CampaignSpecificGlobalContentEditor />
    </Box>
  );
};
